export const isCampaignLabelIdCondition = (field: string) => field === 'campaignLabelId';
